// prettier-ignore
export default function rgbToStr([r, g, b]) {
  return "rgb(" + r + ", " + g + ", " + b + ")";
}